import { render, staticRenderFns } from "./ReversalBody.vue?vue&type=template&id=35e38fa0&scoped=true&"
import script from "./ReversalBody.vue?vue&type=script&lang=js&"
export * from "./ReversalBody.vue?vue&type=script&lang=js&"
import style0 from "./ReversalBody.vue?vue&type=style&index=0&id=35e38fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e38fa0",
  null
  
)

export default component.exports